import React from 'react';

import './BettingPanelOverlay.css';

const BettingPanelOverlay = props => {

	const { reloadPoints, revealAnswer, quitGame, showOverlay, hasPoints } = props;

	const handleClose = evt => {
		showOverlay('reset-not-enough-points');
	}

	const handleRevealAnswer = evt => {
		handleClose(evt);
		revealAnswer(evt);
	}

	const handleQuitGame = evt => {
		handleClose(evt);
		quitGame(evt);
	}

	const overlayContentClassName = hasPoints ? '': ' no-points';
	const headingLabel = hasPoints ? 'You don’t have enough points!' : 'Game Over!';
	const reloadPointsLabel = hasPoints ? 'Watch an ad and...' : 'Reload my points and…';
	const reloadPointsBtnLabel = hasPoints ? 'Get 200 Points'  : 'Continue Playing';
	const revealAnswersBtnLabel = hasPoints ? 'Give Up': 'Show Me the Answer'; 

	return (
		<div className={"crg-overlay-panel"}>
			<div className={"crg-overlay-content" + overlayContentClassName}>
				<div className="host" />
				<div className="crg-msg-container">
					<div className={"close-btn-container"}>
						<a onClick={handleClose} className="close-btn">X</a>
					</div>
					<h1>{headingLabel}</h1>
					<p>{reloadPointsLabel}</p>
					<a onClick={reloadPoints} className={"reload-points-btn"}>{reloadPointsBtnLabel}</a>
					<div className="crg-bp-wager-container">
						<p className="instr">Go back and...</p>
						<a onClick={handleClose} className="wager-btn">Wager Less</a>
					</div>
					<div className="crg-bp-quit-container">
						<a onClick={handleQuitGame} className="quit-btn">Start A New Game</a>
					</div>
					<div className="crg-bp-reveal-answers-container">
						<p className="instr">Watch an Ad and...</p>
						<a onClick={handleRevealAnswer} className="reveal-answer-btn">{revealAnswersBtnLabel}</a>
					</div>
				</div>
			</div>
		</div>
		);
}

export default BettingPanelOverlay;



// WEBPACK FOOTER //
// ./src/components/ChainReactionGame/BettingPanelOverlay.jsx